// extracted by mini-css-extract-plugin
export default {"flex-column":"mainPanel_flex-column__eJ8sd","main-panel":"mainPanel_main-panel__Nm2o4","flex-row":"mainPanel_flex-row__kv+ua","page-size":"mainPanel_page-size__JyNgf"};